import { type InitFlowComponent } from '@capsicum/common';
import { useEffect } from 'react';
import { osName } from 'react-device-detect';

import PWAForceInstallFlow from './pwa-force-install-flow';

export const PwaForceInstallFlowIos: InitFlowComponent = ({ fallback, next, ...props }) => {
	useEffect(() => {
		if (osName.toLocaleLowerCase() !== 'ios') {
			next();
		}
	}, []);

	if (osName.toLocaleLowerCase() === 'ios') {
		return <PWAForceInstallFlow fallback={fallback} next={next} {...props} />;
	}

	return fallback;
};
